import { extractEventContext } from './contexts';
import type { AnalyticsEvent, AnalyticsEventContext } from './types';

/**
 * Transform an event into a raw format for Amplitude/Segment.
 */
export function prepareRawEvent(event: AnalyticsEvent): {
    type: string;
    properties: object;
    context: AnalyticsEventContext;
} {
    const { properties: payload, context } = extractEventContext(event);
    const { type, ...properties } = payload;

    switch (event.type) {
        // Screen/Page views are converted to a unique name depending on the screen/site e.g.
        case 'screen_view':
            return {
                type: `view_${event.screen}`,
                context,
                properties: {
                    ...properties,
                    // Extract the section from the screen (everything before the first underscore)
                    // and add it as a new field.
                    screenSection: event.screen.split('_')[0],
                },
            };

        default:
            return {
                type,
                properties,
                context,
            };
    }
}
